import { IGeoForListPresenterSchema } from '../../repositories/countryside-search/entities/geo/GeoForListPresenterSchema';

const MOSCOW_OBL_ID = 4593;

const DEFAULT_GEO = [1, 0, 0];

export const getLocationIds = (geo: IGeoForListPresenterSchema | null | undefined) => {
  if (!geo || !geo.address || !Array.isArray(geo.address.details)) {
    return DEFAULT_GEO;
  }
  const { details } = geo.address;

  const locationIds = details.filter(item => item.type === 'location').map(item => item.id);

  const result: number[] = [1]; // moId = 1 для MVP.

  if (locationIds.length) {
    if (locationIds[0] === MOSCOW_OBL_ID) {
      result.push(locationIds[1] as number);
    } else {
      result.push(locationIds[0] as number);
    }

    result.push(locationIds[locationIds.length - 1] as number);
  }

  return result;
};
